import { Navigate } from "react-router-dom";
import { FcGoogle } from "react-icons/fc";
import { AuthData } from "../auth/AuthWrapper";

function LoginPage() {
  const { user, signInWithGoogle, isLoadingProfile } = AuthData();

  if (user.isAuthenticated) {
    return <Navigate to="/home" />;
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="mb-4 text-gray-800">Sign In With Google to Continue</div>
      <button
        type="button"
        onClick={signInWithGoogle}
        className="flex items-center gap-2 rounded-md bg-white border border-gray-300 px-4 py-2 shadow hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600 disabled:opacity-60"
        aria-label="Sign in with Google"
        disabled={isLoadingProfile}
        onKeyDown={(e) => {
          if (e.key === "Enter") signInWithGoogle();
        }}
      >
        <FcGoogle className="h-5 w-5" aria-hidden="true" />
        <span className="text-sm font-medium text-gray-700">
          Sign in with Google
        </span>
      </button>
    </div>
  );
}

export default LoginPage;
